/**
 * @generated SignedSource<<84f3bd6af565f68e22bd729f9f500b30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VaultItemAccessDetails_node$data = {
  readonly id: string;
  readonly uploadGroup: {
    readonly publishedAt: {
      readonly utcDate: DateString ;
      readonly utcTime: TimeOfDayString;
    };
    readonly publisher: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"UserHandle_member">;
    };
  };
  readonly " $fragmentType": "VaultItemAccessDetails_node";
};
export type VaultItemAccessDetails_node$key = {
  readonly " $data"?: VaultItemAccessDetails_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"VaultItemAccessDetails_node">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VaultItemAccessDetails_node",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VaultUploadGroup",
      "kind": "LinkedField",
      "name": "uploadGroup",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Member",
          "kind": "LinkedField",
          "name": "publisher",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "UserHandle_member"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DateTime",
          "kind": "LinkedField",
          "name": "publishedAt",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "utcDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "utcTime",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VaultItem",
  "abstractKey": null
};
})();

(node as any).hash = "c8ccc4424596d0ae129fd1061e6412b4";

export default node;
